import { PostBaobPcSupplyGetMessagePopup200DataListItem } from "@/openapi/baob/pc.Supply/api.client.axios";
import { Button, Flex, Modal, Space, theme } from "antd";
import classNames from "classnames";
import Iconfont from "@/components/Iconfont";

interface ShopPerformanceModalProps {
  data: PostBaobPcSupplyGetMessagePopup200DataListItem;
  open: boolean;
  onClose: () => void;
}

const ShopPerformanceModal = ({
  open,
  data,
  onClose,
}: ShopPerformanceModalProps) => {
  const { token: globalToken } = theme.useToken();
  const handleClose = () => {
    onClose();
  };

  const renderContent = () => {
    return (
      <div className="din-bold text-base leading-8">
        {data?.data?.desc?.map((vocabulary, index) => (
          <span
            key={index}
            className={classNames(vocabulary.bold ? "font-bold" : "")}
            style={{ color: `#${vocabulary.color}` }}
          >
            {vocabulary.text}
          </span>
        ))}
      </div>
    );
  };

  return (
    <Modal
      open={open}
      onCancel={handleClose}
      footer={[
        <Flex key="footer" justify="center">
          <Button key="known" type="primary" onClick={handleClose}>
            我知道了
          </Button>
        </Flex>,
      ]}
      maskClosable={false}
      destroyOnClose={true}
    >
      <Space className="text-lg font-bold px-3">
        <Iconfont
          type="icon-a-bianzu4"
          style={{
            color: globalToken.colorPrimary,
          }}
        />
        提示
      </Space>
      <div className="pt-8 pb-2 px-4">{renderContent()}</div>
    </Modal>
  );
};

export default ShopPerformanceModal;
